var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "champagne_glass",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m37.906,86.349c-.734.314-1.153,1.049-.944,1.783.105.734.734,1.259,1.573,1.259h22.965c.734,0,1.363-.525,1.573-1.259.105-.734-.21-1.468-.944-1.783l-11.115-4.299v-20.32c5.872-1.363,10.276-11.688,10.276-25.74,0-6.082-.839-14.198-1.992-24.789-.105-.524-.524-.944-1.049-.944h-16.987c-.524,0-.944.42-1.049.944-1.153,10.591-1.992,18.706-1.992,24.789,0,14.366,4.614,24.797,10.696,25.844v20.216l-11.011,4.299Zm2.412-50.464c0-5.767.734-13.358,1.887-23.635h15.1c1.153,10.172,1.887,17.763,1.887,23.635,0,14.89-4.929,23.853-9.438,23.853-4.509,0-9.437-8.962-9.437-23.853h0Zm9.647,47.949l8.703,3.46h-17.407l8.704-3.46Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }